/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legaroo_Landing_Feature_1Inputs */

const en_service_legaroo_landing_feature_1 = /** @type {(inputs: Service_Legaroo_Landing_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal resources`)
};

const fr_service_legaroo_landing_feature_1 = /** @type {(inputs: Service_Legaroo_Landing_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressources juridiques`)
};

/**
* | output |
* | --- |
* | "Legal resources" |
*
* @param {Service_Legaroo_Landing_Feature_1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legaroo_landing_feature_1 = /** @type {((inputs?: Service_Legaroo_Landing_Feature_1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legaroo_Landing_Feature_1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legaroo_landing_feature_1(inputs)
	return fr_service_legaroo_landing_feature_1(inputs)
});